// extracted by mini-css-extract-plugin
module.exports = {"container":"index_container__VAQQr","backButton":"index_backButton__4UwMG","paginationWrapper":"index_paginationWrapper__Z6Yjr"};